import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ChecklistColumn = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 15,
}));

export const TooltipStyle = styled(Tooltip)(() => ({
  cursor: "help",
  display: "flex",
}));
